/** Shared map iframe / container labels (WCAG 1.4.3, LLSU2-84). */
export const MAP_IFRAME_TITLE = 'LADOT projects map';

export const PROJECTS_MAP_CONTAINER_ARIA_LABEL =
  'Interactive map of LADOT projects across Los Angeles. Use the list view for an accessible alternative.';
